<div *ngIf="isComponentReady && (usedAccountFiled || (isAddNewAccount && additionalFields?.length > 0))" class="bank-account-body" fxLayoutAdivgn="center center">
    <div class="bank-account-form-wrapper">
        <div id="bank-account-form">
            <form name="parentForm" [formGroup]="parentForm">
                <mat-form-field *ngIf="!!usedAccountFiled?.choices && usedAccountFiled?.choices.length > 0" class="used-account" appearance="outline">
                    <mat-label i18n>select account</mat-label>
                    <select matNativeControl name="used-account" formControlName="used_account" (change)="usedAccountChange($event)">
                        <option *ngFor="let item of usedAccountFiled?.choices; let first=first" [selected]="first" [value]="item.value">{{ item.display_name }}
                        </option>
                        <option value="" i18n>Add new account</option>
                    </select>
                    <mat-error *ngIf="parentForm.get('used_account')?.errors?.serverError">
                        {{ parentForm.get('used_account').errors?.serverError }}
                    </mat-error>
                </mat-form-field>
                <ng-container *ngIf="isAddNewAccount && additionalFields?.length > 0">
                    <div fxLayout="column" fxLayoutAlign="center center">

                        <ng-container *ngFor="let item of additionalFields">
                            <ng-container [ngSwitch]="item.type">
                                <mat-checkbox *ngSwitchCase="'checkbox'" color="primary" [formControlName]="item.name" checked>{{item.label}}</mat-checkbox>
                                <input *ngSwitchCase="'hidden'" type="hidden" [formControlName]="item.name" [value]="item.value" />
                                <mat-form-field *ngSwitchCase="'select'" class="used-account" appearance="outline">
                                    <mat-label>{{item.label}}</mat-label>
                                    <select matNativeControl [formControlName]="item.name">
                                        <option *ngFor="let elem of item.choices" [value]="elem.value" selected>{{elem.display_name}}</option>
                                    </select>
                                </mat-form-field>
                                <div style="width:100%; margin-bottom: 18px;">
                                    <mat-form-field *ngSwitchCase="'input'" class="swift" appearance="outline">
                                        <mat-label>{{item.label}}</mat-label>
                                        <input trim matInput type="text" [formControlName]="item.name">

                                    </mat-form-field>
                                    <mat-error *ngIf="parentForm.get(item.name)?.hasError('required')" i18n>This field cannot be empty.</mat-error>
                                    <mat-error *ngIf="parentForm.get(item.name)?.errors?.serverError">
                                        {{ parentForm.get(item.name).errors?.serverError }}
                                    </mat-error>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                </ng-container>
            </form>
        </div>
    </div>
</div>